import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="w-full bg-gray-100 border-t border-gray-200">
      <div className="mx-auto px-6 py-8 lg:px-8">
        <div className="flex items-center justify-center gap-8 text-sm text-gray-600">
          <Link to="/impressum" className="hover:text-gray-900 underline-offset-4 hover:underline">
            Impressum
          </Link>
          <span className="text-gray-400">•</span>
          <Link to="/datenschutz" className="hover:text-gray-900 underline-offset-4 hover:underline">
            Datenschutz
          </Link>
        </div>
      </div>
    </footer>
  );
}
